import * as React from "react";
import { Stack } from "../../components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../components/ui/tooltip";
import {
  Cpu,
  CloudAlert,
  Save,
  WifiPen,
  RadioTower,
  Info,
  Clock,
  Gauge,
} from "lucide-react";
import { ClusterMetricFlag } from "./types";
import capitalize from "lodash/capitalize";

const getFlagIcon = (label: string) => {
  switch (label) {
    case "task errors":
      return <CloudAlert className="text-red-500" />;

    case "cluster memory pressure":
      return <Cpu className="text-yellow-500" />;
    case "individual high memory":
      return <Cpu className="text-red-500" />;

    case "disk used":
      return <Save className="text-yellow-500" />;

    case "network traffic":
      return <WifiPen className="text-gray-500" />;
    case "external network traffic":
      return <RadioTower className="text-gray-500" />;

    case "low cpu utilization":
      return <Gauge className="text-orange-500" />;
    case "idle workers":
      return <Clock className="text-gray-500" />;
    default:
      return <Info className="text-gray-500" />;
  }
};

const getFlagText = (label: string) => {
  switch (label) {
    case "cluster memory pressure":
      return (
        <>
          Cluster Memory Pressure
          <br />
          <br />
          The cluster does not have enough memory available to process the
          workload efficiently. This might result in spilling data to disk which
          causes slowdowns or in killed workers because they run out of memory.
          Further data is available on the Metrics tab. We recommend increasing
          the number of workers or the amount of memory per worker.
        </>
      );
    default:
      return <>{capitalize(label)}</>;
  }
};

export const MetricFlags = ({
  metricFlags,
}: {
  metricFlags?: ClusterMetricFlag[];
}): React.ReactElement => {
  return (
    <Stack
      className="flex-row flex-nowrap ml-2 [&_svg]:w-5 [&_svg]:h-5"
      spacing={2}
    >
      {(metricFlags || []).map((i) => {
        return (
          <TooltipProvider key={i.label}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span>{getFlagIcon(i.label)}</span>
              </TooltipTrigger>
              <TooltipContent>
                <div className="max-w-xs whitespace-pre-line">
                  {getFlagText(i.label)}
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      })}
    </Stack>
  );
};
